import React, { Component } from 'react'

import style from './Grid.css'

export default class Align extends Component {
  render() {
    return (
      <div
        {...this.props}
        className={`
            ${(this.props.sm) ? style['text-sm-'+this.props.sm] : style['text-sm-left']}
            ${(this.props.lg) ? style['text-lg-'+this.props.lg] : style['text-lg-left']}
            ${this.props.className || ''}
          `}
        style={{
          ...this.props.style
        }}
        >
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/Grid/Align.js